"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Storage = /*#__PURE__*/function () {
  function Storage() {
    (0, _classCallCheck2.default)(this, Storage);
  }

  (0, _createClass2.default)(Storage, [{
    key: "get",
    value: function get(key) {
      var value;

      try {
        var data = JSON.parse(localStorage.getItem(key) || '');

        if (data && data.value) {
          if (data.maxAge) {
            if (data.maxAge > Date.now()) {
              value = data.value;
            } else {
              this.remove(key);
            }
          } else {
            value = data.value;
          }
        }
      } catch (error) {}

      return value;
    }
  }, {
    key: "set",
    value: function set(key, value, expires) {
      try {
        var data = {
          value: value,
          maxAge: expires ? Date.now() + expires * 60 * 1000 : null
        };
        localStorage.setItem(key, JSON.stringify(data));
      } catch (error) {}
    }
  }, {
    key: "remove",
    value: function remove(key) {
      localStorage.removeItem(key);
    }
  }, {
    key: "getRaw",
    value: function getRaw(key) {
      var value = {
        value: null,
        maxAge: null
      };

      try {
        var data = JSON.parse(localStorage.getItem(key) || '');

        if (data && data.value) {
          value = data;
        }
      } catch (error) {}

      return value;
    }
  }, {
    key: "isExpired",
    value: function isExpired(key) {
      try {
        var data = JSON.parse(localStorage.getItem(key) || '');

        if (data && data.value) {
          return !(!data.maxAge || data.maxAge && data.maxAge > Date.now());
        } else {
          return true;
        }
      } catch (error) {}

      return true;
    }
  }, {
    key: "append",
    value: function append(key, extra) {
      try {
        var data = JSON.parse(localStorage.getItem(key) || '');

        if (data && data.value) {
          Object.assign(data.value, extra);
          localStorage.setItem(key, JSON.stringify(data));
          return data.value;
        }
      } catch (error) {}
    }
  }]);
  return Storage;
}();

var _default = new Storage();

exports.default = _default;